import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {observable, action} from 'mobx';
import MdDelete from 'react-icons/lib/md/delete';
import ReactPlayer from 'react-player';
import CircularLoader from '../../../../components/CircularLoader';

@observer
class VideoBox extends Component {
    @observable isLoading = true;

    @action handleVideo = () => {
        this.isLoading = false;
    };

    render() {
        return (
            <div className="m-video-wrapper">
                {this.isLoading && <CircularLoader size={36} color="inherit"/>}
                <ReactPlayer
                    className="m-video-player"
                    url={this.props.url}
                    controls={true}
                    onReady={this.handleVideo}
                    onError={this.handleVideo}
                    width="100%"
                    height="100%"
                />
                <div className="remove-btn" onClick={this.props.onRemove}>
                    <MdDelete/>
                </div>
            </div>
        );
    }
}

export default VideoBox;
